import { createAppApi } from '../shared';
import type { APIPayload, APIResponse } from './appConfig';
import type { ParsedValues } from './validation';

const ENDPOINT = '/iSteelPlate/';

export function mapInputToPayload(input: ParsedValues): APIPayload {
  return {
    title: input.title,
    Lx: input.Lx,
    Ly: input.Ly,
    tpl: input.tpl,
    damping: input.damping,
    E: input.E,
    density: input.density,
    orientation: input.orientation,
    support: input.support,
    addedWeight: input.addedWeight,
    Fdy: input.fdy,
    Fdu: input.fdu,
    Pa: input.pressureHistory,
    td: input.timeHistory,
    d0: input.u0,
    v0: input.v0
  };
}

const { analyze, analyzeCancellable } = createAppApi<ParsedValues, APIPayload, APIResponse>(ENDPOINT, mapInputToPayload, { retry: 2, timeout: 15000 });

export { analyze, analyzeCancellable };
